import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import validation from '../utill/validation';
import joi from 'joi';
import { isArray } from 'lodash';
import axios from '../httpServices/httpService';
import config from '../config.json'
import { Select } from 'antd'
import 'antd/dist/antd.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import CustomDataType from './CustomDataType';

function DynamicTable({ ImageList, rows, errors, addRow, handleInputChange, removeRow, columns = [], id,setRows }) {
    const StandardType = [{ label: "Description", value: "Description" }, { label: "Dimension", value: "Dimension" }]
    return (
        <div >
            <table id={id} style={{ display: 'table' }} className="small table-sm table-responsive">
                <thead>
                    <tr className='text-center'>
                        {columns.length > 0 && <th>Standard Type</th>}
                        {columns.map((x) => <th>{x.FieldName}</th>)}
                        {columns.length > 0 && <th ><span>CTQ</span> <input checked={rows.length==rows.filter(x=>x.CTQ).length} onChange={(e) => {
                          const arr=[...rows];
                          arr.forEach(x=>x.CTQ=(e.currentTarget.checked))
                          setRows(arr);
                        }} className='ml-1' type='checkbox' /></th>}
                    </tr>
                </thead>
                <tbody>
                    {rows && isArray(rows) && rows.map((row, index) => (
                        <tr className='text-center' key={index}>
                            {columns.length > 0 && <td>
                                <div >
                                    <Select placeholder="Select Standard Type..." onChange={(value) => {
                                        handleInputChange(index, { target: { name: "StandardType", value: value } })
                                    }} value={row.StandardType || []} style={{ width: "100%" }}>
                                        {StandardType.map((one) => {
                                            return <Select.Option value={one.value}>{one.label}</Select.Option>
                                        })}
                                    </Select>
                                    {errors.StandardType && <div className="alert small alert-danger">{errors['StandardType']}</div>}
                                </div>
                            </td>}
                            {columns.map((field) => <><td>{CustomDataType(field, (e) => handleInputChange(index, e), errors, row, ImageList)}</td></>)}
                            {columns.length > 0 && <td>
                                <div >
                                    <input checked={row.CTQ || false} onChange={(e) => handleInputChange(index, { target: { name: "CTQ", value: e.currentTarget.checked } })} type='checkbox' name={row.StandardType + index} />
                                </div>
                            </td>}
                            {rows.length > 1 && index >= 1 && <td>
                                <FontAwesomeIcon size='2x' onClick={() => removeRow(index)} color='red' icon={faTimesCircle} />
                            </td>}
                        </tr>
                    ))}
                </tbody>
            </table>
            <button className="btn btn-sm btn-primary mt-2 float-right" onClick={addRow}>Add More Checkpoint</button>
        </div>
    );
}

export default DynamicTable;
